// Filter state of the Provider DISCOVERY / SHOP contexts, kept in the URL so it is shareable and the
// catalog, the drawer and the Home all read the same source of truth.
// `country` = the Provider's own address/location; `madeIn` = the PRODUCT's country of
// manufacture (ticket §1) -- two independent fields, never merged.
export const EMPTY_FILTERS = { categoryId: "", wholesale: false, dropshipping: false, pa: false, inStock: false, minPrice: "", maxPrice: "", maxMinimumQuantity: "", country: "", madeIn: "", attr: [] };

const BOOLS = ["wholesale", "dropshipping", "pa", "inStock"];
const TEXTS = ["categoryId", "minPrice", "maxPrice", "maxMinimumQuantity", "country", "madeIn"];

export const filtersFromParams = (params) => ({
  ...EMPTY_FILTERS,
  ...Object.fromEntries(TEXTS.map((k) => [k, params.get(k) || ""])),
  ...Object.fromEntries(BOOLS.map((k) => [k, params.get(k) === "1"])),
  attr: params.getAll("attr"),
});

// Writes the filters into `params` (returned), leaving unrelated params (q, sort, tab, providerId...) alone.
export const filtersToParams = (filters, params = new URLSearchParams()) => {
  const next = new URLSearchParams(params);
  [...TEXTS, ...BOOLS, "attr"].forEach((k) => next.delete(k));
  TEXTS.forEach((k) => filters[k] && next.set(k, filters[k]));
  BOOLS.forEach((k) => filters[k] && next.set(k, "1"));
  (filters.attr || []).forEach((a) => next.append("attr", a));
  next.delete("page");
  return next;
};

export const countActiveFilters = (f) =>
  [...TEXTS, ...BOOLS].filter((k) => f[k] && f[k] !== "").length + (f.attr?.length || 0);
